export default __webpack_public_path__ + "static/media/horizontal-bar-chart.7e981c4e.svg";